// extracted by mini-css-extract-plugin
export var backdropBlur = "_er-0";
export var contentCard = "_er-5";
export var frame = "_er-2";
export var image = "_er-4";
export var imagePane = "_er-3";
export var modal = "_er-1";